export const PageHeader = ({ kicker, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8 fade-up">
    <div>
      <p className="font-mono text-[11px] tracking-widest text-blue-600 mb-2">{kicker}</p>
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">{title}</h1>
    </div>
    <div className="flex items-center gap-2">{children}</div>
  </div>
);
